// extracted by mini-css-extract-plugin
export default {"InfoContainer":"_InfoContainer--HkhIR","Insight":"_Insight--vIvZx","WorkspaceName":"_WorkspaceName--VCM1f"};